import { enableWorkWithBrowser } from '@shared/util/browserDetector';

export function* allowToWorkWithBrowser() {
  enableWorkWithBrowser();
}
